import { render } from "./ContactUsView.vue?vue&type=template&id=4e520f98&scoped=true"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"

import "./ContactUsView.vue?vue&type=style&index=0&id=4e520f98&lang=css&scoped=true"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e520f98"]])

export default __exports__